export default function EFClock(props: any) {
    return (
        <svg
            width="20px"
            height="20px"
            viewBox="0 0 20 20"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink"
            {...props}
        >
            <g id="页面-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                <g id="Where-to-Buy_02" transform="translate(-176.000000, -627.000000)">
                    <g id="编组-11" transform="translate(160.000000, 430.000000)">
                        <g id="编组-2备份-2" transform="translate(16.000000, 197.000000)">
                            <rect id="矩形" x="0" y="0" width="20" height="20"></rect>
                            <g id="编组" transform="translate(2.000000, 2.000000)" stroke="#757575" strokeLinejoin="round">
                                <path
                                    d="M8,16 C12.41828,16 16,12.41828 16,8 C16,3.58172 12.41828,0 8,0 C3.58172,0 0,3.58172 0,8 C0,12.41828 3.58172,16 8,16 Z"
                                    id="路径"
                                ></path>
                                <polyline id="路径" strokeLinecap="round" points="8.00056608 3 8 8.27519255 11.2172959 11.2165329"></polyline>
                            </g>
                        </g>
                    </g>
                </g>
            </g>
        </svg>
    );
}
